import z from "zod/v4";
import { TenantIdCodec } from "@visioni/a3s-schema/codecs";

export const TenantScope = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("customer"), id: z.string(), name: z.union([z.string(), z.null()]) }),
  z.object({ kind: z.literal("branch"), code: z.string(), name: z.union([z.string(), z.null()]) }),
  z.object({ kind: z.literal("test"), unique: z.string() }),
]);
export type TenantScope = z.infer<typeof TenantScope>;

/** Identifying fields only — used for lookups where name is not needed. */
export const TenantScopeKey = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("customer"), id: z.string() }),
  z.object({ kind: z.literal("branch"), code: z.string() }),
  z.object({ kind: z.literal("test"), unique: z.string() }),
]);
export type TenantScopeKey = z.infer<typeof TenantScopeKey>;

export const TenantInfo = z.object({
  id: TenantIdCodec,
  scopes: z.array(TenantScope).readonly(),
});
export type TenantInfo = z.infer<typeof TenantInfo>;

export const TenantChange = z.object({
  action: z.literal("set"),
  info: TenantInfo,
});
export type TenantChange = z.infer<typeof TenantChange>;
